/** Delete a KB article */
export const kbArticleDeleteSpec = {
    uri: '/kb/article/[article]',
    method: 'DELETE',
    adminOnly: true,
};
